<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="KeHuList" data-title="乙方管理">
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column :width="400">
          <template #header>
            <div class="c-table-col-header" label1="名称" label2="所属单位" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row.d_belong_unit_name">
              <template #top>
                <div
                  class="flex items-center gap-x-2 text-green-700 cursor-pointer hover:underline"
                  @click="
                    $openMenu({
                      path: 'BaoZhangDanWeiDetail',
                      title: '乙方单位详情-' + row.name,
                      refresh: true,
                      data: {
                        id: row.id,
                      },
                    })
                  "
                >
                  <strong>{{ row.name }}</strong>
                  <text>{{ "[" + row.number + "]" }}</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="负责人" label2="地址" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row.address" :key="row.address">
              <template #top>
                <div class="flex items-center gap-x-3">
                  <text>{{ row.contact_name }}</text>
                  <c_sex :value="row.contact_title == '先生' ? '男' : '女'" />
                  <text>{{ $phoneFormat(row.contact_phone) }}</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="协议期">
          <template #default="{ row }">
            <text v-if="row.contract_time">
              {{ row.contract_time + " ~ " + row.contract_time_end }}
            </text>
            <text v-else>-</text>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" :formatter="$tab_TextFormat" />
        <el-table-column label="状态" align="center">
          <template #default="{ row }">
            <el-switch
              v-model="row.status"
              active-text="启用"
              inactive-text="禁用"
              :active-value="1"
              :inactive-value="0"
              :disabled="!row.id"
              inline-prompt
              @change="onUpdateStatus($event, row)"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="balance"
          label="账户余额"
          align="center"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column label="对接人" :width="140" fixed="right">
          <template #default="{ row }">
            <text>{{ row.belonger_name }}</text>
            <text class="text-gray-400 text-xs ml-1">{{
              row.belonger_department_name
            }}</text>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" :width="320">
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              @click="
                state.selectId = row.id;
                state.showChange = true;
              "
            >
              <template #icon>
                <svg viewBox="0 0 1024 1024">
                  <path
                    d="M762.503311 141.113925c-14.285355-9.653871-33.714869-5.90243-43.363623 8.393157-9.658987 14.295588-5.907547 33.709753 8.388041 43.367717 106.359376 71.861678 169.863712 191.280488 169.863712 319.443449 0 212.412784-172.811858 385.220548-385.220548 385.220548S126.956484 724.732056 126.956484 512.318248c0-128.168078 63.49922-247.586888 169.858596-319.443449 14.295588-9.658987 18.057261-29.073152 8.398274-43.363623-9.648754-14.295588-29.073152-18.052145-43.363623-8.398274C138.267087 224.602408 64.488757 363.373984 64.488757 512.318248c0 246.854201 200.827935 447.687252 447.682136 447.687252S959.859167 759.173472 959.859167 512.318248C959.859167 363.373984 886.075721 224.607524 762.503311 141.113925z"
                    fill="var(--el-color-primary)"
                    p-id="11152"
                  />
                  <path
                    d="M400.698055 64.636113c-17.248849 0-31.233352 13.984503-31.233352 31.233352l0 30.470989c0 17.248849 13.985526 31.233352 31.233352 31.233352 17.248849 0 31.233352-13.985526 31.233352-31.233352L431.931407 95.869465C431.931407 78.621639 417.946904 64.636113 400.698055 64.636113z"
                    fill="var(--el-color-primary)"
                    p-id="11153"
                  />
                  <path
                    d="M623.649869 64.636113c-17.248849 0-31.233352 13.984503-31.233352 31.233352l0 30.470989c0 17.248849 13.985526 31.233352 31.233352 31.233352 17.248849 0 31.233352-13.985526 31.233352-31.233352L654.883221 95.869465C654.883221 78.621639 640.897695 64.636113 623.649869 64.636113z"
                    fill="var(--el-color-primary)"
                    p-id="11154"
                  />
                  <path
                    d="M425.695379 227.656977c11.209296 18.047028 41.974997 48.588625 86.157265 48.588625 43.958164 0 75.100442-30.3134 86.573751-48.223305 9.302877-14.528901 5.068436-33.846876-9.455349-43.149752-14.544251-9.29776-33.846876-5.063319-43.149752 9.455349-0.121773 0.198521-13.379729 19.449981-33.968649 19.449981-20.008706 0-32.443923-18.127869-33.276894-19.373233-9.165754-14.427594-28.285207-18.799158-42.829458-9.760295C421.089477 193.749726 416.59 213.006302 425.695379 227.656977z"
                    fill="var(--el-color-primary)"
                    p-id="11155"
                  />
                  <path
                    d="M356.00311 591.05859c-17.248849 0-31.233352 13.984503-31.233352 31.233352s13.984503 31.233352 31.233352 31.233352L480.93754 653.525294l0 98.250698c0 17.248849 13.984503 31.238468 31.233352 31.238468 17.248849 0 31.233352-13.989619 31.233352-31.238468l0-98.250698 124.93443 0c17.248849 0 31.238468-13.984503 31.238468-31.233352s-13.989619-31.233352-31.238468-31.233352L543.405267 591.05859l0-83.289961 124.93443 0c17.248849 0 31.238468-13.985526 31.238468-31.233352 0-17.248849-13.989619-31.233352-31.238468-31.233352l-80.761372 0 68.041676-68.038606c12.20088-12.20088 12.20088-31.976272 0.005117-44.171012-12.195763-12.20088-31.976272-12.195763-44.171012-0.005117l-99.280144 99.276051-99.280144-99.276051c-12.190647-12.190647-31.971156-12.195763-44.171012 0.005117-12.195763 12.195763-12.195763 31.971156 0.005117 44.171012l68.041676 68.038606-80.766488 0c-17.248849 0-31.233352 13.984503-31.233352 31.233352 0 17.248849 13.984503 31.233352 31.233352 31.233352L480.93754 507.768629l0 83.289961L356.00311 591.05859z"
                    fill="var(--el-color-primary)"
                    p-id="11156"
                  />
                </svg>
              </template>
              充值/扣款
            </el-button>
            <el-button
              type="warning"
              :icon="Edit"
              link
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
            >
              编辑
            </el-button>
            <el-button
              type="success"
              :icon="Connection"
              link
              @click="
                $openMenu({
                  path: 'BaoZhangDanWeiDetail',
                  title: '乙方单位详情-' + row.name,
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
            >
              管理
            </el-button>
            <el-button type="danger" :icon="Delete" link @click="onDelete(row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="`${state.selectId ? '编辑' : '新建'}乙方单位`"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
  >
    <c_info
      :id="state.selectId"
      @close="
        (refresh) => {
          state.showInfo = false;
          if (refresh) onLoad();
        }
      "
    />
  </el-dialog>
  <el-dialog
    v-model="state.showChange"
    title="充值/扣款"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showChange = false;
      }
    "
    :width="400"
  >
    <c_change
      :bill_unit_id="state.selectId"
      @close="
        (refresh) => {
          state.showChange = false;
          if (refresh) onLoad();
        }
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { billunit_page, billunit_delete } from "@/http/billunit";
import { onDeleteConfirm, post_response } from "@/utils/funcs";
import { ElMessageBox } from "element-plus";
import c_info from "./Info.vue";
import c_change from "./ChangeBalance.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  components: {
    c_info,
    c_change,
  },
  setup() {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      billunit_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(billunit_delete, row.id, onLoad, {
        filed: "客户",
        name: row.name,
      });
    };

    const onUpdateStatus = (value, row) => {
      ElMessageBox.confirm(
        `您确定${
          row.status == 1
            ? '<strong style="color: var(--el-color-success);">启用</strong>'
            : '<strong style="color: var(--el-color-danger);">禁用</strong>'
        }该乙方单位吗？`,
        "状态变更",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      )
        .then(() => {
          billunit_updateStatus({
            id: row.id,
            status: row.status,
          }).then((res) => {
            post_response(res, onLoad);
          });
        })
        .catch(() => {
          row.status = value ? 0 : 1;
        });
    };

    return { state, onLoad, onDelete, onUpdateStatus };
  },
};
</script>

<style lang="scss" scoped></style>
